import { PropertyType, PropertyFormat } from '@rappider/rappider-components/utils';
import { AddParameterValue } from 'libs/data-transformation/src/lib/shared';

export const DEFAULT_ADD_PARAMETER_VALUE_DATA: AddParameterValue = {
  type: PropertyType.String,
  format: null,
  value: null,
  key: null
};
